import { useQuery } from "@apollo/client";

import { ProjectMapEditorScreen_GetProjectDocument } from "../queries.generated";

export default function useProjectMapEditorScreen_GetProject(projectId: string) {
    const { data, loading, error } = useQuery(ProjectMapEditorScreen_GetProjectDocument, {
        variables: { projectId, projectIdString: projectId },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });

    return {
        projectData: data?.projectGetById,
        functionTypes: data?.projectGetFunctionTypesById,
        observationTypes: data?.projectGetObservationTypesById,
        researchTypes: data?.projectGetResearchTypesById,
        layers: data?.mapEditorLayerGetAll?.data,
        loading,
        error,
    };
}
